import axios from 'axios'
import { i18n } from '../../../../plugins/i18n'

export const companiesStoreGmbCategories = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareApi(state) {
      state.loading = true
    },
    apiSuccess(state,) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    readGmbCategories(state) {
      state.data = null
      state.loading = true
    },
    readGmbCategoriesSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
    },
    readGmbCategoriesFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readGmbCategories({ commit }, { companyUuid, storeUuid }) {
      commit('readGmbCategories')
      return axios
        .get(`/api/companies/${ companyUuid }/stores/${ storeUuid }/gmb/categories.json`)
        .then(res => {
          commit('readGmbCategoriesSuccess', res.data)
        })
        .catch(err => {
          commit('readGmbCategoriesFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    updateGmbCategories({ commit }, { companyUuid, storeUuid, payload }) {
      commit('flash/clearFlash', null, { root: true })
      commit('prepareApi')
      return axios
        .put(`/api/companies/${ companyUuid }/stores/${ storeUuid }/gmb/categories.json`, payload)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.gmbSiteSetting.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
